import { render, staticRenderFns } from "./UpdateImageModal.vue?vue&type=template&id=043d1d82&"
import script from "./UpdateImageModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateImageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports